export default __webpack_public_path__ + "static/media/step_B@2x.489d38ea.png";